"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var container_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/designated/container_store"));
var Designated = function (props) {
    var store = (0, mobx_react_1.useLocalStore)(function () { return new container_store_1.default(props); });
    return react_1.default.createElement(store_component_1.default, { store: store });
};
exports.default = Designated;
